export const sliderInfo = [
  {
    id: 1,
    title: "Enfermedad por el nuevo coronavirus",
    description:
      "La COVID-19 afecta de distinas maneras en función de cada persona",
    imageUrl: require("../assets/images/sliders/1.png").default,
    altImg: "Slider 1",
  },
  {
    id: 2,
    title: "Enfermedad por el nuevo coronavirus",
    description:
      "La COVID-19 afecta de distinas maneras en función de cada persona",
    imageUrl: require("../assets/images/sliders/1.png").default,
    altImg: "Slider 1",
  },
  {
    id: 3,
    title: "Enfermedad por el nuevo coronavirus",
    description:
      "La COVID-19 afecta de distinas maneras en función de cada persona",
    imageUrl: require("../assets/images/sliders/1.png").default,
    altImg: "Slider 1",
  },
];

export const metrics = {
  users: "2m",
  countries: "78",
  doctors: "10,000+",
};

export const services = [
  {
    id: 1,
    title: "Comprobador de síntomas",
    description:
      "Compruena si está infectado por COVID-19 con nuestro Comprobador de síntomas.",
    icon: "person",
  },
  {
    id: 2,
    title: "Soporte médico 24x7",
    description:
      "Consulte con más de 10.000 trabajadores de la salud acerca de sus inquietudes.",
    icon: "medican",
  },
  {
    id: 3,
    title: "Condiciones",
    description: "Llevando funciones de atención médica premium a tu alcance.",
    icon: "heart",
  },
];
